var EVENT_TYPES = {
    //https://github.com/wix-private/chat-server/blob/master/chat/chat-core/src/main/scala/com/wix/corechat/domain/Event.scala
    MESSAGE_SENT: 'MessageSent',
    MESSAGE_DELETED: 'MessageDeleted',
    MESSAGE_UPDATED: 'MessageUpdated',
    CHATROOM_DELETED: 'ChatroomDeleted',
    CHATROOM_CREATED: 'ChatroomCreated',
    CHATROOM_MERGED: 'ChatroomMerged',
    TYPING_STARTED: 'TypingStarted',
    TYPING_STOPPED: 'TypingStopped',
    CHATROOOM_DISPLAY_DATA_UPDATED: 'ChatroomDisplayDataUpdated',
    CHATROOM_ARCHIVED: 'ChatroomArchived',
    CHATROOM_UNARCHIVED: 'ChatroomUnarchived',
    CHATROOM_READ: 'ChatroomRead',
    CHATROOMS_ALL_READ: 'AllChatroomsMarkedAsRead',
    CHATROOM_UNREAD: 'ChatroomUnread',
    MESSAGE_INDICATION_UPDATE: 'MessageIndicationUpdate',
    PRESENCE_EVENT: 'Presence',
    EXTERNAL_HOST: 'ExternalHost',
    OFFLINE_CHANNEL_UPDATED: 'ParticipantOfflineChannelUpdated',
    LABEL_ADDED: 'LabelAddedToChatrooms',
    LABEL_REMOVED: 'LabelRemovedFromChatrooms',
};
export default EVENT_TYPES;
